import { Link } from 'react-router-dom'
import { ImageContainer } from '../constants/ImagesConstants'
import { Config } from '../config/Config';
import { FormattedMessage } from 'react-intl';

const PageNotFound = () => {




    return (
        <>
            <div className='pagenotfound'>
                <div className='text-center'>
                    <img alt="page not found" src={ImageContainer?.NotFoundImage} />
                    <h1 className='my-4'><FormattedMessage id="page_not_found" /> </h1>
                    <Link to="/" className="btn btn-fill"><FormattedMessage id="go_back" /></Link>
                </div>
            </div>


        </>
    )
}

export default PageNotFound